module.exports = __webpack_public_path__ + "img/fzds3.ea27ad5c.png";